import React from 'react'
import PrintAble from '../../components/Printable'
import dayjs from 'dayjs'

import { sides, damageType, resourceUrl } from '../../util'

export const ReportForm = ({ car, imgs, branchID = "" }) => {
    if (!car) return null
    return (
        <PrintAble>
            <div className="text-right text-lg">
                <header>
                    <img
                        src={`${resourceUrl}/banners/banner${branchID}.png`}
                        alt="header"
                        width="100%"
                        height="120mm"
                        style={{
                            position: "fixed",
                            top: "0mm",
                            left: "0mm",
                            zIndex: '-1',
                            maxHeight: '120mm'
                        }}
                    />
                </header>
                <div className="page" style={{ marginTop: "30mm", fontWeight: 'bold' }}>
                    <h4>معلومات عامة</h4>
                    <h4>من نحن</h4>
                    <p style={{ textAlign: 'justify', direction: 'rtl' }}>
                        بدي كار علامة تجارية مسجلة قانونياُ مختصة بخدمات السيارات تأسست سنة 2020 ومقرها الرئيسي في بغداد المنصور،
                        بدي كار هي الوكيل حصري لشركة scan Theta الالمانية في العراق، حرصت بدي كار على بناء سمعة طيبة في مجال فحص
                        السيارات من خلال إنشاء مراكزها المنتشرة في العراق بأحدث المعدات وفريق من الفنيين المتميزين.
                    </p>
                </div>
                <div className="page">
                    <h4>مفردات الفحص: </h4>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        1. Pre-delivery inspection : PDI - PDS
                        فحص ما قبل التسليم:
                        عملية فحص يقوم بها الوكيل أو الشركة مصنعة قبل تسليم السيارة الجديدة للزبون يشمل هذا الفحص الصواميل والمسامير والإطارات اضافة الى عدة نقاط اخرى، لذلك في بعض السيارات من الممكن وجود فتح جزئي او كلي للقطعة من اجل موازنة القطعة.
                    </p>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        2. PDR:
                        هي عملية إصلاح الخدوش أو الرصعات بدون طلاء، تشمل الخدوش أو الرصعات الناتجة عن الاصطدام،
                        طالما لم يحدث أي ضرر في طلاء السيارة او المعدن لايمكن تحديد الPDR او الكشف عنه من خلال تكنلوجيا الفحص.
                    </p>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        3. Triple Coat - Double Coat:
                        طبقة صبغ اضافية في المركبة، يحدث هذا بسبب خلل فني خلال عملية الطلاء او اثناء تجميع قطع المركبة ف يتم اعادة طلاء المركبة في المصنع تقديرا من الشركة للزبون،
                        لذلك يجب ان لايعتبر ضرر في المركبة.
                    </p>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        4. في حال وجود إنبعاجات (رصعات) في السيارة يتم تحديدها ولايمكن تحليلها إن كانت
                        (حالوب – حصى متطاير – ضرر متعمد).
                    </p>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        5. هذا الفحص لا يتضمن الفقرات المتعلقة بمديرية المرور العامة وتقارير شركات التأمين والمزادات الاجنبية
                    </p>
                    <p style={{ fontWeight: 'bold', textAlign: 'justify', direction: 'rtl' }}>
                        6. إخلاء المسؤولية بعد الفحص:
                        المبالغ المستحصلة من الزبون هي أتعاب مركز الفحص لتبيان رأيهم في حالة السيارة ولاتعتبر هذه المبالغ كفالة او تأمين للسيارة، لذلك نخلي مسؤوليتنا بعد انتهاء الفحص وتسليم التقرير للزبون.
                    </p>
                </div>
                <h4>دلائل التقرير اللونية :</h4>
                <div className="page" style={{ margin: '5mm', fontWeight: 'bold', }}>
                    <div className="flex flex-col">
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "2rem", backgroundColor: '#870040' }}></div>
                            <span className="mx-2">يدل على وجود طلاء محلي في المكان المحدد</span>
                        </div>
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "0.5rem", backgroundColor: '#870040' }}></div>
                            <span className="mx-2">يدل على وجود تكحيل في المكان المحدد</span>
                        </div>
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "2rem", backgroundColor: '#EFE0BA' }}></div>
                            <span className="mx-2">يدل على إستبدال القطعة المحددة</span>
                        </div>
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "2rem", backgroundColor: '#BAF2D8' }}></div>
                            <span className="mx-2">يدل على وجود طرق في المعدن (سمكرة بارد) في الاماكن المحددة</span>
                        </div>
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "0.5rem", backgroundColor: '#F2BACD' }}></div>
                            <span className="mx-2">يدل على وجود خدش في المكان المحدد</span>
                        </div>
                        <div className="flex items-center" style={{ marginTop: '2mm', marginBottom: '2mm' }}>
                            <div style={{ width: "5rem", height: "2rem", backgroundColor: 'transparent', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: "1rem", height: "1rem", borderRadius: '50%', backgroundColor: '#F2BACD' }}>
                                </div>
                            </div>
                            <span className="mx-2">يدل على وجود إنبعاج (رصعة) في المكان المحدد</span>
                        </div>
                    </div>
                </div>
                <div className="pagebreak"></div>
                <div className="page" style={{ marginTop: '35mm', fontWeight: 'bold', fontSize: '14px' }}>
                    تقرير الفحص النهائي :
                </div>
                <div className="flex flex-wrap justify-between">
                    <div className="flex flex-col justify-start items-start" style={{ width: '48%', margin: 0, marginBottom: '5mm', fontWeight: 'bold' }}>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> الماركة : {car.brand}</span>
                            <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> النوع : {car.model}</span>
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> سنة الصنع : {car.year}</span>
                            <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> رقم العجلة : {car.plateNo} {car.plateType}</span>
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-full leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> رقم الهيكل : {car?.vinNo}</span>
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "0mm" }}>
                            <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> تاريخ الفحص : {dayjs(car.created_at).format("YYYY-MM-DD")}</span>
                            <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0, fontSize: '14px' }}> وقت الفحص : {dayjs(car.created_at).format("hh:mm a")}</span>
                        </span>
                        <span style={{ marginTop: '5mm', fontSize: '14px' }}>
                            ملاحظة : نخلي مسؤوليتنا بعد انتهاء الفحص وتسليم التقرير الى الزبون.
                        </span>
                        <span style={{ marginTop: '5mm', fontSize: '14px' }}>
                            ملاحظة : يرجى قراءة الملاحظات في الصفحة الاولى.
                        </span>
                    </div>
                    {Object.keys(sides).map((k, i) => {
                        return (
                            <div key={k} style={{ width: '48%', margin: 0 }}>
                                <div key={k} className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                    <img src={imgs[`${k}`]} width="100%" height="200mm" alt={k} />
                                    <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                        <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm', fontSize: '14px' }}>{sides[k]}</h5>
                                        <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm', whiteSpace: 'normal', fontSize: '13px' }}>
                                            {car.report[`${k}Note`]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <footer>
                    <img
                        src={`${resourceUrl}/banners/footer${branchID}.png`}
                        alt="footer"
                        width="100%"
                        height="120mm"
                        style={{
                            position: "fixed",
                            bottom: '0mm',
                            left: '0mm',
                            maxHeight: '120mm'
                        }}
                    />
                    <div style={{ position: 'fixed', bottom: '10mm', right: '0', margin: '5mm' }}>
                        {`تقرير الفحص النهائي للعجلة المرقمة
                    ${car.plateNo} - ${car.plateType}
                    بتاريخ ${dayjs(car.created_at).format("YYYY-MM-DD")}
                    في الساعة ${dayjs(car.created_at).format("hh:mm a")}
                    `}
                    </div>
                </footer>

            </div>
        </PrintAble >
    )
}
